var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup",
    staticStyle: {
      "padding": "0px",
      "height": "100%"
    },
    attrs: {
      "data-w-id": "cc289cfd-0be4-7987-a2cf-7e1c631923e0"
    }
  }, [_c('chat-content', {
    attrs: {
      "client": _vm.payload,
      "quick-message": _vm.quickMessage
    },
    on: {
      "quickMessageSet": function quickMessageSet($event) {
        _vm.quickMessage = null;
      }
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }